export default function StatusBar() {
  return (
    <footer className="statusbar">
      <span className="ok">●</span> connected to api.entryrate.io
      <span className="sep">·</span>
      <span>Skiddle <span className="ok">OK</span></span>
      <span>DICE <span className="ok">OK</span></span>
      <span>Fatsoma <span className="ok">OK</span></span>
      <span>RA <span className="ok">OK</span></span>
      <span>Eventbrite <span className="ok">OK</span></span>
      <span>Ticketmaster <span style={{color:"var(--warn)"}}>re-auth needed</span></span>
      <div className="right">
        <span>schema 2026.05.01</span>
        <span>tz Europe/London</span>
        <span>⌘? for shortcuts</span>
      </div>
    </footer>
  );
}
